module.exports = __webpack_public_path__ + "assets/img/btn-download-xbox-c5a704a9.png";